import React from 'react';

/**
 * Tab navigation component for proposals page
 * Tabs: Active | Referrals | Archived (matching Upwork's structure)
 */
const ProposalTabs = ({ activeTab, onTabChange, counts = {} }) => {
  const tabs = [
    { id: 'active', label: 'Active', count: counts.active || 0 },
    { id: 'referrals', label: 'Referrals', count: counts.referrals || 0 },
    { id: 'archived', label: 'Archived', count: counts.archived || 0 },
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8" aria-label="Proposal tabs">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                relative py-4 px-1 text-sm font-medium transition-colors
                ${isActive
                  ? 'text-primary-600'
                  : 'text-gray-500 hover:text-gray-700'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              <span className="flex items-center gap-2">
                {tab.label}
                {tab.count > 0 && (
                  <span
                    className={`
                      inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-medium
                      ${isActive
                        ? 'bg-primary-100 text-primary-600'
                        : 'bg-gray-100 text-gray-600'
                      }
                    `}
                  >
                    {tab.count}
                  </span>
                )}
              </span>
              {/* Active indicator */}
              {isActive && (
                <span
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600"
                  aria-hidden="true"
                />
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default ProposalTabs;
